import type { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { StyleableButtonSelect } from "../../../components/button/add-styleable-button-form";
import { PollAlignment } from "../poll-alignment";
import { PollOptions } from "../poll-options";
import type { PollWrapperSchema } from "../types";

export const PollFormCustomAnswerType: FC = () => {
  const form = useFormContext<PollWrapperSchema>();

  return (
    <>
      <PollOptions />
      <PollAlignment />
      <Controller
        name="poll.answer_type.button_type"
        control={form.control}
        render={({ field, fieldState: { error } }) => (
          <StyleableButtonSelect onChange={field.onChange} selected={field.value} error={error} />
        )}
      />
    </>
  );
};
